import React, { createContext, useReducer } from 'react'
import { get, isEmpty } from 'lodash'
import { getWorkingPath } from 'hookrouter/dist/router'

const Context = createContext('app-theme')
const { Provider } = Context

const linkSelector = () => {
  return {
    primaryLinks: [{ title: 'Home', slug: '/' }],
    footerLinks: [{ slug: '/home', title: 'Home' }],
    childLinks: []
  }
}

const StateProvider = props => {
  //const [items, dispatch] = useReducer(myCrud.reducer)

  // if (!items) {
  //   myCrud.getEntries({}, dispatch)
  // }

  const state = {
    data: { links: linkSelector() }
  }

  return (
    <Provider
      {...props}
      value={{
        state,
        dispatch: {}
      }}
    />
  )
}

export { Context as ThemeContext, StateProvider as default }
